(($)=>{

    "use strict";

	$('.platform-select-title').click(function(){
		$(this).siblings('.platform-select-hidden').toggleClass('open');
	});

})(jQuery);